import React from 'react';
import { useTranslation } from 'react-i18next';
import familyImage from '@/assets/images/subscription/1.webp';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';

interface Props {
  onPurchase: () => void;
}

export const NotificationSubscriptionBanner: React.FC<Props> = ({
  onPurchase,
}) => {
  const { t } = useTranslation();

  return (
    <div className="relative mx-4 flex flex-col gap-2 overflow-hidden rounded-xl bg-info-surface px-4 pt-4 pb-2">
      <p className="text-subhead-14">
        <span className="text-foreground">
          {t('notificationSettings.bannerTitle')}
        </span>{' '}
        <span className="text-subtle-foreground">
          {t('notificationSettings.bannerStatus')}
        </span>
      </p>
      <button
        type="button"
        onClick={onPurchase}
        className="flex h-9 cursor-pointer items-center gap-2 self-start text-subhead-14 text-primary"
      >
        {t('notificationSettings.bannerButton')}
        <ArrowLeft className="size-4 rotate-180" />
      </button>
      <img
        src={familyImage}
        alt=""
        aria-hidden
        className="pointer-events-none absolute right-0 bottom-[-11px] size-20 object-contain"
      />
    </div>
  );
};
